import type { AppCrashKind } from '@/api/appCrashes';

/**
 * Подписи страницы «Падения приложения» (T23). Здесь, а не в `lib/`: сторож `studentFacingWords`
 * считает ученическим любой ключ, упомянутый в `lib/`.
 */

/** Явные ключи вида: строка с дефисом в имени ключа — лишний повод для ошибки. */
export const CRASH_KIND_KEY: Record<AppCrashKind, string> = {
  'js-error': 'adminAppCrashes.kindJs',
  unhandled: 'adminAppCrashes.kindUnhandled',
  'previous-launch-crash': 'adminAppCrashes.kindPrevLaunch',
};

/** «iOS 17.5», «Android 13», без системы — пусто. */
export function systemLabel(platform: string, os: string): string {
  const name = platform === 'ios' ? 'iOS' : platform === 'android' ? 'Android' : '';
  return [name, os].filter(Boolean).join(' ');
}

/**
 * iOS 26 подписывает себя в UA как 18.6 (разбор 11.10, docs/CHECK-2026-10-11-APP-CRASHES.md) — 18.6 в
 * своде может быть и 26. Подпись нужна, чтобы это не читалось как «все на 18.6».
 */
export function mayBeIOS26(platform: string, os: string): boolean {
  return platform === 'ios' && os.startsWith('18.6');
}

/** «1.1.2 (63)», без версии — пусто. */
export function versionLabel(version: string, build: string): string {
  if (!version) return '';
  return build ? `${version} (${build})` : version;
}
